import React from 'react'
import star from '../../utils/star.svg'
import './ReviewCard.scss'

export const reviews = [
	{
		author: 'Gosia & Pedro',
		text: 'Z całego serca polecamy Czary Marry! Dzięki nim nasze wesele było przepiękne, dopracowane w każdym szczególe, a goście wciąż są zachwyceni. Kreatywne, profesjonalne, z dbałością o detale i ogromnym wsparciem w ważnych chwilach. Na zawsze pozostaniecie nieodzowną częścią tego wyjątkowego dla nas dnia.'
	},
	{
		author: 'Helena & Guillermo',
		text: 'Dziewczyny nas uratowały! :) Współpraca z nimi to bajka, są pomocne, cierpliwe, kreatywne, otwarte, ratują z opresji i zawsze wspierają! Jeśli jesteście zajęci i nie potraficie w organizację, to nawet się nie zastanawiajcie - bardzo, bardzo polecamy, będziemy zawsze miło wspominać dziewczyny :) bez nich nic by się nie udało! Uroczystość była cudowna:)'
	},
	{
		author: 'Adrian',
		text: 'Miałem przyjemność współpracować z Kasią i Olą przy organizacji wesela jako podwykonawca. Wszystko przebiegło bez problemów, na wysokim poziomie, a i pogoda dopisała. Jasne informacje, plan i rozmowa pozwoliły mi pracować bez stresu. Wysoki profesjonalizm – polecam!'
	},
	{
		author: 'Marta & Taras',
		text: 'Dziękujemy Oli i Kasi za spełnienie naszych marzeń o idealnym weselu! Wszystko dopracowane w każdym detalu, harmonogram perfekcyjny, goście zachwyceni. Dziewczyny są kreatywne, pomocne, cierpliwe i pełne pomysłów. W 4 miesiące zorganizowały magiczny, bezstresowy dzień. Polecamy! '
	},
	{
		author: 'Kuba',
		text: 'Absolutnie najlepszy duet pod słońcem. Dziewczyny zadbają o Was na każdym etapie ślubu i wesela. Przeprowadzą Was przez przygotowania i wszystkie niespodziewane trudności Cechuje je duża empatia, wrażliwość i świetny gust. Ostrzegam, bardzo łatwo się z nimi zaprzyjaźnić ;) Dzięki za doskonałą współpracę.'
	}
]

export const ReviewCard = ({ author, children }) => {
	return (
		<div className='review-card-wrapper'>
			<div className='review-card'>
				<div className='stars-wrapper'>
					<img src={star} alt='Star icon' className='star-icon' />
					<img src={star} alt='Star icon' className='star-icon' />
					<img src={star} alt='Star icon' className='star-icon' />
					<img src={star} alt='Star icon' className='star-icon' />
					<img src={star} alt='Star icon' className='star-icon' />
				</div>
				<div className='review-card_content'>
					<p className='review-card_text'>"{children}"</p>
				</div>
				<div className='review-card_author'>
					<span>
						~<i>{author}</i>
					</span>
				</div>
			</div>
		</div>
	)
}
